import { queryClient } from "@contexts";
import type { NavigateFunction } from "react-router-dom";
import type { PDFData, RequestType } from "@interfaces";
import { requestTypeNavigateParser } from "@interfaces";
import { removeFromLocalStorage } from "@utils";
import type { NotifyPrescriptionsParams } from "./notifyPrescriptions";

interface SignDocumentOnSuccessProps {
  requestType: RequestType;
  requestId: string;
  navigate: NavigateFunction;
  notifyPrescription: (params: NotifyPrescriptionsParams) => Promise<void>;
  data: PDFData[];
}

export const signDocumentOnSuccess = async ({
  requestType,
  requestId,
  navigate,
  notifyPrescription,
  data,
}: SignDocumentOnSuccessProps): Promise<void> => {
  removeFromLocalStorage("requestType");
  removeFromLocalStorage("compoundedPrescriptionDetails");
  queryClient.invalidateQueries({ queryKey: ["requests"] });
  queryClient.invalidateQueries({ queryKey: ["request", requestId] });

  try {
    await notifyPrescription({ requestId });
    console.log(`Document of type ${requestType} notified successfully`);
  } catch (error) {
    console.error(`Error notifying prescription of type ${requestType}:`, {
      error,
    });
    // Do not throw the error, it will be handled at another level
  }

  navigate(
    `/app/solicitudes/${requestId}/${requestTypeNavigateParser[requestType]}/exito`,
    {
      state: { documentPDFData: data },
    },
  );
};
